// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-popup-container{position:absolute;pointer-events:none}.error-popup-container.depth-zero{z-index:0 !important}.error-popup-container.depth-three{z-index:3 !important}", ""]);
// Exports
module.exports = exports;
